import { render } from "./AzureRedirect.vue?vue&type=template&id=18b3d1cc&scoped=true"
import script from "./AzureRedirect.vue?vue&type=script&lang=js"
export * from "./AzureRedirect.vue?vue&type=script&lang=js"

import "./AzureRedirect.vue?vue&type=style&index=0&id=18b3d1cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b3d1cc"]])

export default __exports__